// Umami Analytics helper
// Provides a simple interface to track events with user role context
// Only tracks in production when Umami is loaded

/**
 * Track an event with Umami analytics
 * Automatically includes user role from window.USER_ROLE
 *
 * @param {string} eventName - The event name (max 50 chars)
 * @param {object} data - Additional event data (optional)
 *
 * Usage:
 *   import { trackEvent } from "../umami"
 *   trackEvent('Report Generated', { report_type: 'excel' })
 *   trackEvent('File Uploaded')
 */
export function trackEvent(eventName, data = {}) {
  // Only track if Umami is loaded (production/staging)
  if (typeof window.umami === 'undefined') {
    return
  }

  // Add user role to all events
  const eventData = {
    role: window.USER_ROLE || 'unknown',
    ...data
  }

  try {
    window.umami.track(eventName, eventData)
  } catch (e) {
    // Silently fail - analytics should never break the app
  }
}
